import React, { useEffect, useState, useRef } from "react";
import { useAtom } from "jotai";
import axios from "axios";
import { gbState } from "../../../components/shared/GlobalState";
import CardTile from "./CardTile";
import { useLocation } from "react-router-dom";
import { HiUsers } from 'react-icons/hi';

const FamilyMembersChild = () => {
  const { state } = useLocation();

  const [{ errorLogApi, placeHolderText, Category, user }] = useAtom(gbState);
  let selected_hof = state;
  // if (!state) {
  //   selected_hof = user?._id;
  // }

  const [data, setData] = useState(null);
  useEffect(() => {
    let userToken = localStorage.getItem("token");
    let urlLink = `${process.env.REACT_APP_API_URL}/family/${user.church_id}`;
    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };
    axios(config)
      .then(function (response) {
        const oldData = response.data.families;
        setData(oldData);
        //setData(showFamily(oldData, user?._id));
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  }, []);

  //Show members from my Family
  const showFamily = (data, primaryMemberId) => {
    return data.filter(
      (family) => family.primary_member_id._id === primaryMemberId
    );
  };

  return (
    <div className="flex flex-grow min-h-screen bg-gray-50">
      <div className="px-4 py-8 mx-auto w-full max-w-7xl sm:px-6 lg:px-8">
        <div className="flex flex-col">
          {/* Header Section */}
          <div className="mb-8">
            <div className="flex justify-between items-center">
              <div>
                <h1 className="text-3xl font-bold text-gray-900">Family Members</h1>
                <p className="mt-2 text-gray-600">
                  View and manage your family members
                </p>
              </div>
              <div className="hidden sm:block">
                <div className="p-3 bg-white rounded-xl shadow-sm">
                  <div className="flex items-center space-x-2">
                    <HiUsers className="w-5 h-5 text-indigo-500" />
                    <span className="text-sm font-medium text-gray-600">
                      {data?.length || 0} Members
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4 w-32 h-1 bg-indigo-500 rounded-full"></div>
          </div>
          {/* Members List */}
          {data && (
            <CardTile
              familiesData={data}
              hof={selected_hof}
              current_hof={user?._id}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default FamilyMembersChild;
